import React from 'react';

const ThumbnailBg = ({ color = '#504EB9', hasEducatorImg = true }) => {
  return (
    <svg
      width="1136"
      height="521"
      viewBox="0 0 1136 521"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1168_432375)">
        <rect
          width="1136"
          height="521"
          rx="8"
          fill={color}
          fillOpacity="0.25"
        />
        <g
          style={{ mixBlendMode: 'color-burn' }}
          filter="url(#filter0_f_1168_432375)"
        >
          <path
            d="M920.843 -224.678C767.992 275.821 422.805 625.093 -388.078 865.876H1323.58V-224.678H920.843Z"
            fill="url(#paint0_linear_1168_432375)"
            fillOpacity="0.2"
          />
        </g>
        <g filter="url(#filter1_f_1168_432375)">
          <circle
            cx="132.394"
            cy="261.499"
            r="377.214"
            fill="white"
            fillOpacity="0.3"
          />
        </g>
        {hasEducatorImg && (
          <g opacity="0.1" filter="url(#filter2_f_1168_432375)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M235.523 82.3116C284.466 91.0549 312.948 151.169 299.139 216.58C296.187 230.563 291.542 243.656 285.584 255.515C307.998 282.043 325.707 317.148 334.944 357.408C357.856 457.273 319.959 551.04 250.299 566.841C180.639 582.642 105.594 514.495 82.6825 414.63C65.8407 341.222 81.8559 271.109 119.192 232.836C117.62 217.701 118.405 201.479 121.901 184.918C135.71 119.507 186.58 73.5683 235.523 82.3116Z"
              fill={color}
            />
          </g>
        )}
        {!hasEducatorImg && (
          <g opacity="0.4">
            <path
              d="M112 286.384C112 356.864 169.308 414 240 414C310.692 414 368 356.864 368 286.384V277.396C368 271.536 363.235 266.785 357.358 266.785H122.642C116.765 266.785 112 271.536 112 277.396V286.384Z"
              fill={color}
              fillOpacity="0.5"
            />
            <path
              d="M170.971 178.594C170.971 216.477 201.876 247.188 240 247.188C278.123 247.188 309.028 216.477 309.028 178.594C309.028 140.71 278.123 110 240 110C201.876 110 170.971 140.71 170.971 178.594Z"
              fill={color}
              fillOpacity="0.5"
            />
            <path
              d="M282.338 295.701C283.604 303.591 290.563 309.624 298.957 309.624C307.266 309.624 314.168 303.712 315.535 295.94C315.71 295.211 315.782 294.628 315.76 294.128C315.76 293.556 315.343 293.112 314.764 293.112H283.164C282.586 293.112 282.169 293.556 282.168 294.127C282.167 294.127 282.169 294.127 282.168 294.127C282.169 294.14 282.166 294.153 282.166 294.165C282.151 294.6 282.207 295.099 282.338 295.701Z"
              fill="white"
            />
            <path
              d="M307.216 320.012C306.583 316.068 303.104 313.051 298.907 313.051C294.752 313.051 291.301 316.007 290.618 319.893C290.531 320.258 290.494 320.549 290.505 320.799C290.505 321.085 290.714 321.307 291.004 321.307H306.803C307.093 321.307 307.301 321.085 307.302 320.799C307.301 320.799 307.302 320.799 307.302 320.799C307.301 320.793 307.303 320.787 307.302 320.78C307.31 320.563 307.282 320.314 307.216 320.012Z"
              fill="white"
            />
          </g>
        )}
      </g>
      <defs>
        <filter
          id="filter0_f_1168_432375"
          x="-498.375"
          y="-334.974"
          width="1932.25"
          height="1311.15"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="55.1482"
            result="effect1_foregroundBlur_1168_432375"
          />
        </filter>
        <filter
          id="filter1_f_1168_432375"
          x="-260.82"
          y="-131.715"
          width="786.43"
          height="786.429"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="8"
            result="effect1_foregroundBlur_1168_432375"
          />
        </filter>
        <filter
          id="filter2_f_1168_432375"
          x="52.7254"
          y="57.9695"
          width="312.174"
          height="534.422"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="11.6373"
            result="effect1_foregroundBlur_1168_432375"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1168_432375"
          x1="702.418"
          y1="503.875"
          x2="1210.4"
          y2="-112.099"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor={color} stopOpacity="0.5" />
        </linearGradient>
        <clipPath id="clip0_1168_432375">
          <rect width="1136" height="523" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ThumbnailBg;
